export default "__VITE_ASSET__CfdmrYsZ__"